export default function ArrowDownSortPopoverIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_948_82902"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect
          x="12"
          y="12"
          width="12"
          height="12"
          transform="rotate(-180 12 12)"
          fill="#D9D9D9"
        />
        <rect
          x="11.5"
          y="11.5"
          width="11"
          height="11"
          transform="rotate(-180 11.5 11.5)"
          stroke="black"
          strokeOpacity="0.2"
        />
      </mask>
      <g mask="url(#mask0_948_82902)">
        <mask id="path-3-inside-1_948_82902" fill="white">
          <path d="M6.5 2L6.5 8.0875L9.3 5.2875L10 6L6 10L2 6L2.7 5.2875L5.5 8.0875L5.5 2H6.5Z" />
        </mask>
        <path
          d="M6.5 2L6.5 8.0875L9.3 5.2875L10 6L6 10L2 6L2.7 5.2875L5.5 8.0875L5.5 2H6.5Z"
          fill="#1C1B1F"
        />
        <path
          d="M6.5 2H7.5V1H6.5V2ZM6.5 8.0875H5.5V10.5017L7.20711 8.79461L6.5 8.0875ZM9.3 5.2875L10.0133 4.58668L9.30629 3.867L8.59289 4.58039L9.3 5.2875ZM10 6L10.7071 6.70711L11.408 6.00623L10.7133 5.29918L10 6ZM6 10L5.29289 10.7071L6 11.4142L6.70711 10.7071L6 10ZM2 6L1.28666 5.29918L0.592016 6.00623L1.29289 6.70711L2 6ZM2.7 5.2875L3.40711 4.58039L2.69371 3.867L1.98666 4.58668L2.7 5.2875ZM5.5 8.0875L4.79289 8.79461L6.5 10.5017V8.0875H5.5ZM5.5 2V1H4.5V2H5.5ZM5.5 2L5.5 8.0875H7.5L7.5 2H5.5ZM7.20711 8.79461L10.0071 5.99461L8.59289 4.58039L5.79289 7.38039L7.20711 8.79461ZM8.58666 5.98832L9.28666 6.70082L10.7133 5.29918L10.0133 4.58668L8.58666 5.98832ZM9.29289 5.29289L5.29289 9.29289L6.70711 10.7071L10.7071 6.70711L9.29289 5.29289ZM6.70711 9.29289L2.70711 5.29289L1.29289 6.70711L5.29289 10.7071L6.70711 9.29289ZM2.71334 6.70082L3.41334 5.98832L1.98666 4.58668L1.28666 5.29918L2.71334 6.70082ZM1.99289 5.99461L4.79289 8.79461L6.20711 7.38039L3.40711 4.58039L1.99289 5.99461ZM6.5 8.0875L6.5 2H4.5L4.5 8.0875H6.5ZM5.5 3L6.5 3V1H5.5V3Z"
          fill="black"
          fillOpacity="0.2"
          mask="url(#path-3-inside-1_948_82902)"
        />
      </g>
    </svg>
  );
}
